const { get, post, put, del } = require("network/http/api")

export const getCompany = () => {
  return get(`/company/me`)
}
